import React, { ReactNode } from "react"
import { IoIosClose } from "react-icons/io"

interface ModalProps {
  title: string
  isOpen: boolean
  text: ReactNode
  toggleModal: () => void
}

export function Modal({ title, isOpen, toggleModal, text }: ModalProps) {
  if (isOpen) {
    return (
      <div className="bg-black bg-opacity-90 fixed top-0 left-0 bottom-0 right-0 z-50">
        <div className="bg-sand p-8 rounded-2xl absolute z-50 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full lg:max-w-4xl max-w-[90%] max-h-[80vh]">
          <div className="relative flex flex-col h-full">
            <button type="button" title="Fechar Modal" onClick={toggleModal}>
              <IoIosClose className="text-3xl absolute -right-7 -top-7" />
            </button>
            <div className="overflow-hidden h-full">
              {title && <h2 className="font-serif text-green-dark text-center text-2xl mb-4 shrink-0">{title}</h2>}

              {text}
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return null
  }
}
